module.exports = __webpack_public_path__ + "img/jpg2_zixunliebiao.6eda6b66.png";